import { createContext } from '@lit/context';
import { LitElement } from 'lit';

import {
  PrintExampleDto2,
  putSavePrintExampleForConfiguration,
} from '@/api-sdk';

export interface PrintExampleContextType {
  controller: AbortController;
  service?: PrintExampleDto2;
}

export const printExample = {
  /**
   * Current unique value of the print example data saved in the context
   */
  context: createContext<PrintExampleContextType | undefined>(
    Symbol('print-example-context'),
  ),
  updateProviderEvent(
    element: LitElement,
    printExampleContext?: PrintExampleDto2 | null,
  ) {
    element.dispatchEvent(
      new CustomEvent('update-print-example', {
        composed: true,
        detail: {
          printExample: {
            service: printExampleContext,
            controller: new AbortController(),
          },
        },
      }),
    );
  },
  /**
   * Save print example
   *
   * @param printExampleContext {PrintExampleDto}
   * @param configurationId {string}
   */
  async save(printExampleContext?: PrintExampleDto2, configurationId?: string) {
    if (printExampleContext && configurationId) {
      await putSavePrintExampleForConfiguration({
        uuid: configurationId,
        data: { printExampleId: printExampleContext.uuid },
      });
    }
  },
};
